import { useServiceWorker } from './useServiceWorker'

export const ServiceWorker = () => {
  useServiceWorker()
  return null
}
